import { render, staticRenderFns } from "./view-non-conformance.vue?vue&type=template&id=9d55b4d8&scoped=true&"
import script from "./view-non-conformance.vue?vue&type=script&lang=js&"
export * from "./view-non-conformance.vue?vue&type=script&lang=js&"
import style0 from "./view-non-conformance.vue?vue&type=style&index=0&id=9d55b4d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d55b4d8",
  null
  
)

export default component.exports